import { Component, inject, ChangeDetectionStrategy } from '@angular/core'

import { MatTableModule } from '@angular/material/table'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet'
import { TranslationService } from '../../../../../../services/translation.service'
import { FprPlasticResin } from '../../../../../../types/resins'

export type PlasticResin = {
  napcsCodeId: string
  resinType: string
  resinSource: string
  weightPerUnitKg: number
}

@Component({
  selector: 'app-plastic-resins-sheet',
  imports: [MatTableModule, MatButtonModule, MatIconModule],
  templateUrl: './plastic-resins-sheet.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './plastic-resins-sheet.component.scss',
})
export class PlasticResinsSheetComponent {
  private ref =
    inject<MatBottomSheetRef<PlasticResinsSheetComponent>>(MatBottomSheetRef)
  translationService = inject(TranslationService)
  data = inject<{
    productName: string
    sku: string
    plasticResins: Array<FprPlasticResin>
  }>(MAT_BOTTOM_SHEET_DATA)

  displayedColumns = ['resinType', 'resinSource', 'weightPerUnitKg']

  totalPerUnit(): number {
    return (this.data.plasticResins || []).reduce(
      (acc, r) => acc + (r?.weightPerUnitKg || 0),
      0,
    )
  }

  close() {
    this.ref.dismiss()
  }
}
